module.exports = __webpack_public_path__ + "ef708efb3bb44233140a157d91e87957.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2021-06-10/whats-new.html
// module id = 2250
// module chunks = 0